// extracted by mini-css-extract-plugin
export default {"logoSmall":"Logo_logoSmall__MD+fd","logoLarge":"Logo_logoLarge__nFtxv","teamLogo":"Logo_teamLogo__jyshE"};